import { Box, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import { PASSWORD_REQUIREMENTS_STRINGS } from './strings'

type TPasswordValidation = {
  length: boolean
  uppercase: boolean
  lowercase: boolean
  digit: boolean
}

type TPasswordRequirementsProps = {
  validation: TPasswordValidation
}

export const PasswordRequirements = ({ validation }: TPasswordRequirementsProps) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
        {PASSWORD_REQUIREMENTS_STRINGS.title}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {validation.length ? (
            <CheckCircleIcon color="success" fontSize="small" />
          ) : (
            <ErrorIcon color="error" fontSize="small" />
          )}
          <Typography variant="caption" color={validation.length ? 'success.main' : 'error.main'}>
            {PASSWORD_REQUIREMENTS_STRINGS.length}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {validation.uppercase ? (
            <CheckCircleIcon color="success" fontSize="small" />
          ) : (
            <ErrorIcon color="error" fontSize="small" />
          )}
          <Typography
            variant="caption"
            color={validation.uppercase ? 'success.main' : 'error.main'}
          >
            {PASSWORD_REQUIREMENTS_STRINGS.uppercase}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {validation.lowercase ? (
            <CheckCircleIcon color="success" fontSize="small" />
          ) : (
            <ErrorIcon color="error" fontSize="small" />
          )}
          <Typography
            variant="caption"
            color={validation.lowercase ? 'success.main' : 'error.main'}
          >
            {PASSWORD_REQUIREMENTS_STRINGS.lowercase}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {validation.digit ? (
            <CheckCircleIcon color="success" fontSize="small" />
          ) : (
            <ErrorIcon color="error" fontSize="small" />
          )}
          <Typography variant="caption" color={validation.digit ? 'success.main' : 'error.main'}>
            {PASSWORD_REQUIREMENTS_STRINGS.digit}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
